import {
  Box,
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useRouter } from 'next/router';
import * as React from 'react';

import {  CheckIcon } from '@/imports/ui/chakra/feather'; 


interface RequestSubmittedModalProps {
  isOpen: boolean;
  organizationName?: string;
  membershipType?: string;
  userEmail?: string;
  onClose: () => void;
  onViewStatus?: () => void;
}

export const RequestSubmittedModal: React.FC<RequestSubmittedModalProps> = ({
  isOpen,
  organizationName,
  onClose,
}) => {
  const router = useRouter();

  const handleClose = () => {
    onClose();
    router.push('/me/profile');
  };

  const handleViewStatus = () => {
    onClose();
    router.push('/me/membership-requests');
  };

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent maxW="600px" borderRadius="xl">
        <ModalCloseButton mt="2" mr="2" />
        <ModalHeader pt="6" pb="2">
          <Text fontSize="xl" fontWeight="semibold">
            Request submitted
          </Text>
          <Text fontSize="sm" color="gray.600" fontWeight="normal" mt="1">
            You will be notified when a decision is made.
          </Text>
        </ModalHeader>
        <ModalBody pb="6">
          <Stack spacing="4">
            
 
            <Box
              bg="green.50"
              border="1px solid"
              borderColor="green.200"
              borderRadius="md"
              p="6"
            >
              <Stack spacing="4" align="center">
                <Box
                  w="42px"
                  h="42px"
                  borderRadius="full"
                  bg="green.500"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <CheckIcon w="20px" h="20px" color="white" />
                </Box>
                <VStack spacing="1" align="center" textAlign="center">
                  <Text fontSize="md" fontWeight="bold" color="gray.900">
                    Your request is submitted successfully.
                  </Text>
                  <Text fontSize="sm" color="gray.800">
                    Your request to join <strong>{organizationName}</strong> has been sent to the organization administrator.
                  </Text>
                </VStack>
              </Stack>
            </Box>

            <Box
              bg="blue.50"
              border="1px solid"
              borderColor="blue.100"
              borderRadius="md"
              p="4"
            >
              <Text fontSize="sm" color="gray.800">
                You can track the request from your profile under <strong>Membership Requests</strong>. Membership benefits will activate only after approval.
              </Text>
            </Box>

            <HStack w="full" justify="space-between" pt="2">
              <Button variant="outline" onClick={handleClose} colorScheme="blue">
                Close
              </Button>
              <Button colorScheme="blue" onClick={handleViewStatus}>
                View request status
              </Button>
            </HStack>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
